import { TableProps } from "antd";
import { TablePaginationConfig } from "antd/es/table/Table";
import EventLocationDateTime, { EventLocationTimeIndicator } from "components/EventLocationDateTime";
import { Table } from "components/styleguide";
import AttendeeStatus from "enums/AttendeeStatus";
import { AttendeeStatusHistoryModel } from "generated/api";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import styles from "./styles.module.less";

interface Props {
  loading: boolean;
  rows: AttendeeStatusHistoryModel[];
  pagination: TablePaginationConfig;
  onChange: TableProps<AttendeeStatusHistoryModel>["onChange"];
  baseAttendeeDetailsLink: string;
  timezoneId?: string | null;
}

const AttendeeStatusHistoryTable = ({
  rows,
  loading,
  pagination,
  onChange,
  baseAttendeeDetailsLink,
  timezoneId,
}: Props) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("New Status"),
      dataIndex: "newStatus",
      render: (status: number) => t(`attendeeStatus.${AttendeeStatus.toDisplayName(status)}`),
    },
    {
      title: t("Previous Status"),
      dataIndex: "previousStatus",
      render: (status: number) => t(`attendeeStatus.${AttendeeStatus.toDisplayName(status)}`),
    },
    {
      title: t("Replaced For/By"),
      dataIndex: "relatedForumAttendeeName",
      render: (data: string, record: AttendeeStatusHistoryModel) => {
        if (!record.relatedForumAttendeeId) return "-";
        return (
          <Link className={styles.link} to={`${baseAttendeeDetailsLink}/${record.relatedForumAttendeeId}`}>
            {data}
          </Link>
        );
      },
    },
    {
      title: (
        <span className={styles.modifiedOnTitle}>
          {t("Modified On")}
          <EventLocationTimeIndicator date={rows[0]?.modifiedOn} timezoneId={timezoneId} />
        </span>
      ),
      dataIndex: "modifiedOn",
      sorter: true,
      render: (date: string) => date && <EventLocationDateTime date={date} timezoneId={timezoneId} />,
    },
    {
      title: t("Modified By"),
      dataIndex: "modifiedBy",
    },
  ];

  return (
    <Table
      loading={loading}
      columns={columns}
      dataSource={rows}
      rowKey={"id"}
      pagination={pagination}
      onChange={onChange}
    />
  );
};

export default AttendeeStatusHistoryTable;
